module.exports = __webpack_public_path__ + "img/EOS-alt.aabb40d5.svg";